import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Briefcase, Trophy, BrainCircuit } from 'lucide-react';
export function Solution() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const credentials = [{
    icon: <Briefcase className="w-5 h-5 text-accent" data-id="element-152" />,
    text: 'Former consultants, bankers, operators, and founders'
  }, {
    icon: <Trophy className="w-5 h-5 text-accent" data-id="element-153" />,
    text: 'Selected from the most competitive programs globally'
  }, {
    icon: <BrainCircuit className="w-5 h-5 text-accent" data-id="element-154" />,
    text: 'Trained in the latest frameworks, AI tools, and strategic thinking'
  }];
  return <section className="py-24 md:py-32 bg-secondary border-t border-border" data-id="element-155">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-156">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-157">
          <div data-id="element-158">
            <motion.h2 variants={itemVariants} className="text-xs text-accent tracking-[0.2em] uppercase mb-4" data-id="element-159">
              The MBA Company
            </motion.h2>
            <motion.h3 variants={itemVariants} className="text-4xl md:text-5xl font-serif text-text-light leading-tight mb-8" data-id="element-160">
              A new model for strategy consulting.
            </motion.h3>
            <motion.p variants={itemVariants} className="text-text-muted text-lg leading-relaxed mb-8" data-id="element-161">
              We assemble bespoke teams of elite MBA candidates from the world's
              top 50 business schools to tackle your most important business
              challenges—fast, intelligently, and cost-effectively.
            </motion.p>

            <motion.div variants={itemVariants} className="inline-block bg-primary border border-accent/30 px-6 py-3 mb-10" data-id="element-162">
              <span className="text-text-light font-serif text-xl italic" data-id="element-163">
                These are not interns.
              </span>
            </motion.div>
          </div>

          <div className="space-y-6" data-id="element-164">
            <motion.div variants={itemVariants} className="text-sm text-text-muted uppercase tracking-widest mb-2" data-id="element-165">
              They are:
            </motion.div>
            {credentials.map((cred, idx) => <motion.div key={idx} variants={itemVariants} className="flex items-start space-x-6 p-6 bg-primary border border-border hover:border-accent/40 transition-colors duration-300" data-id="element-166">
                <div className="mt-1 bg-secondary p-3 rounded-full border border-border" data-id="element-167">
                  {cred.icon}
                </div>
                <p className="text-text-light font-serif text-lg leading-relaxed" data-id="element-168">
                  {cred.text}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}